import React from "react";
import { Redirect } from "react-router";
import { Container, Row, Col } from "shards-react";
import EditProjectSuperAdmin from "../components/project/EditProjectSuperAdmin";

class EditProjectPageSuperAdmin extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      should_redirect: false,
    };
    this.pathToRedirect = {
      pathname: "/",
      state: {
        type: "",
        message: "",
      },
    };
    this.redirectToProjectDetails = this.redirectToProjectDetails.bind(this);
  }

  redirectToProjectDetails(pathname, notify_message) {
    this.pathToRedirect = {
      pathname,
      state: {
        type: notify_message.type,
        message: notify_message.message,
      },
    };
    this.setState({ should_redirect: true });
  }

  render() {
    const { should_redirect } = this.state;
    if (should_redirect)
      return (
        <Redirect
          to={{
            ...this.pathToRedirect,
          }}
        />
      );

    return (
      <Container fluid className="main-content-container px-4">
        <Row className="py-3">
          <Col lg="12">
            <EditProjectSuperAdmin
              projectId={this.props.match.params.id}
              redirectToProjectDetails={this.redirectToProjectDetails}
            />
          </Col>
        </Row>
      </Container>
    );
  }
}

export default EditProjectPageSuperAdmin;
